const USER_ERROR_NAME = 'UserError';
export class UserError extends Error {
    constructor(message, field, code) {
        super();
        this.name = USER_ERROR_NAME;
        this.message = message;
        this.field = field || '';
        this.code = code || 400;
        Object.setPrototypeOf(this, UserError.prototype);
    }
}
UserError.NAME = USER_ERROR_NAME;
//# sourceMappingURL=UserError.js.map